import {Reducer} from "redux";
import {
    AccessType,
    BookFeel,
    CoverLook,
    DraftManuScriptType,
    FinalManuScriptType,
    iAccessRight,
    iAddressType,
    iAreaOfExpertise,
    iAuthorship,
    iBookCoverSize,
    iCountry,
    iCountryState,
    iDepartment,
    iDiscipline,
    iEntityTypes,
    iGenre,
    iManuscriptOrigins,
    iManuscriptStatuses,
    PublicationStatuses
} from "./apis/common.apis";
import {User} from "./apis/admin.apis";
import {BookSize, Currency, Package, PreviousPublicationStatus, PricingRegion} from "./apis/price.management.apis";
import {iApiBasicResponse, iMultilevelStringOrNumber} from "./apis/base.apis";
import {iBindingType} from "./apis/admin/ecomerce/binding.types.apis";
import {iCartResponse} from "./apis/order.apis";
import {iDeliveryCategory} from "./apis/admin/delivery/Delivery.apis";
import {AuthorStats} from "./apis/author.apis";
import {getPageQuery} from "./components/QueryParser";

export interface CoverDesignPrefill {
    code: string
    name: string
}

export interface iMaster extends iApiBasicResponse {
    accepted_genres: iGenre[] | undefined
    accepted_disciplines: iDiscipline[] | undefined
    entity_types: iEntityTypes[] | undefined
    book_cover_sizes: iBookCoverSize[] | undefined
    countries: iCountry[] | undefined,
    address_types: iAddressType[] | undefined,
    areas_of_expertise: iAreaOfExpertise[] | undefined,
    proposal_statuses: string[] | undefined,
    proposal_statuses_active: string[] | undefined,
    disciplines: iDiscipline[] | undefined,
    genres: iGenre[] | undefined,
    manuscript_origins: iManuscriptOrigins[] | undefined,
    manuscript_statuses: iManuscriptStatuses[] | undefined,
    authorships: iAuthorship[] | undefined,
    admin_departments: iDepartment[] | undefined,
    admin_access_rights: iAccessRight[] | undefined,
    country_states: iCountryState[] | undefined,
    access_types: AccessType[] | undefined,
    publication_statuses: PublicationStatuses[] | undefined,
    draft_manuscript_file_type: DraftManuScriptType[] | undefined,
    final_manuscript_file_type: FinalManuScriptType[] | undefined,
    packages: Package[] | undefined,
    book_sizes: BookSize[] | undefined,
    pricing_regions: PricingRegion[] | undefined,
    previous_publication_status: PreviousPublicationStatus[] | undefined,
    cover_design_template_prefills: CoverDesignPrefill[] | undefined,
    book_feels: BookFeel[] | undefined,
    cover_looks: CoverLook[] | undefined,
    peer_review_report_file_types: PeerReviewReportFileType[] | undefined
    binding_types_with_mrp_grid: iBindingType[] | undefined
    delivery_categories: iDeliveryCategory[] | undefined
    currencies: Currency[] | undefined
    one_usd_in_euro: number | undefined
}

export interface PeerReviewReportFileType {
    code: string
    id: number
    name: string
    required: number

}

export interface iAdminMaster {

}
export interface iAddedToCart {
    product_id:number,
    added_at:number
}

export interface iStoreState extends iMaster {
    loggedInUser: User | undefined,
    ip_country: iCountry | undefined,
    cart?: iCartResponse,
    updating_cart?: number,
    added_to_cart: iAddedToCart[] ,
    fonts_downloaded?: string[],
    masters_not_loaded?: string,
    author_stats?: AuthorStats,
}


export type iStoreAction =
    | { type: 'verifying_user' }
    | { type: 'failed_to_user' }
    | { type: 'set_logged_in_user', loggedInUser: User | undefined }
    | { type: 'logout', }
    | { type: 'ip_country', ip_country: iCountry }
    | { type: 'masters', masters: iMaster }
    | { type: 'masters_not_loaded', masters_not_loaded: string }
    | { type: 'cart', cart: iCartResponse, updating_cart?: number,added_to_card?: iAddedToCart[] }
    | { type: 'add_font', font: string }
    | { type: 'remove_font', font: string }
    | { type: 'updating_cart', updating_cart?: number, }
    | { type: 'added_to_cart', added_to_cart:  iAddedToCart[] }

    | { type: "author_stats", author_stats?: AuthorStats }


export const getInitialStoreState = (): iStoreState => {
    return {
        loggedInUser: undefined,
        countries: undefined,
        areas_of_expertise: undefined,
        address_types: undefined,
        disciplines: undefined,
        genres: undefined,
        manuscript_origins: undefined,
        manuscript_statuses: undefined,
        authorships: undefined,
        admin_access_rights: undefined,
        admin_departments: undefined,
        country_states: undefined,
        access_types: undefined,
        draft_manuscript_file_type: undefined,
        final_manuscript_file_type: undefined,
        packages: undefined,
        book_sizes: undefined,
        pricing_regions: undefined,
        previous_publication_status: undefined,
        ip_country: undefined,
        proposal_statuses: undefined,
        proposal_statuses_active: undefined,
        publication_statuses: undefined,
        accepted_disciplines: undefined,
        accepted_genres: undefined,
        entity_types: undefined,
        book_cover_sizes: undefined,
        cover_design_template_prefills: undefined,
        cover_looks: undefined,
        book_feels: undefined,
        statusCode: 200,
        peer_review_report_file_types: undefined,
        binding_types_with_mrp_grid: undefined,
        cart: undefined,
        updating_cart: undefined,
        delivery_categories: undefined,
        fonts_downloaded: undefined,
        currencies: undefined,
        masters_not_loaded: undefined,
        author_stats: undefined,
        one_usd_in_euro:undefined,
        added_to_cart:[]
    }
};

export function appReducer(state: iStoreState, action: iStoreAction): iStoreState {
    switch (action.type) {
        case 'set_logged_in_user':

            window.localStorage.setItem('loggedInUser_spectrum', (action.loggedInUser && action.loggedInUser?.email) || "");
            return {...state, loggedInUser: action.loggedInUser,};
        case 'ip_country':
            return {...state, ip_country: action.ip_country};
        case 'logout':
            window.localStorage.removeItem('loggedInUser_spectrum');
            return {...state, loggedInUser: undefined, cart: undefined};
        case "masters":
            return {...state, ...action.masters};
        case "cart":
            if (action.updating_cart !== undefined) {
                return {...state, cart: action.cart, updating_cart: action.updating_cart};
            }
            return {...state, cart: action.cart};
        case "masters_not_loaded":
            return {...state, masters_not_loaded: action.masters_not_loaded};
        case "author_stats":
            return {...state, author_stats: action.author_stats};
        case "add_font":
            return {
                ...state,
                fonts_downloaded: state.fonts_downloaded ? [...state.fonts_downloaded, action.font] : [action.font]
            };
        case "remove_font":
            return {
                ...state,
                fonts_downloaded: state.fonts_downloaded ? [...state.fonts_downloaded.filter(value => {
                    return value !== action.font
                })] : []
            };
        case "updating_cart":
            return {...state, updating_cart: action.updating_cart,};
        case "added_to_cart":
            return {...state, added_to_cart: action.added_to_cart,};
        default:
            return {...state};
    }
}


export interface iListingQuery extends iMultilevelStringOrNumber {
    page?: number
    per_page?: number
    sort_order?: string
    sort_direction?: "desc" | "asc"
    keyword?: string
}

export type iListResponseActions<T> =
    | { type: "loading" }
    | { type: "soft_loading" }
    | { type: "failed", error?: string }
    | { type: "failed_to_load", error?: string }
    | { type: "success", resource?: T }
    | { type: "query", query: iListingQuery }
    | { type: "go_to_page", page: number }
    | { type: "search", keyword: string }
    | { type: "on_sort_change", query: iListingQuery }
    | { type: "per_page", per_page: number }

export interface iListResource<T> {
    loading: boolean,
    soft_loading?: boolean,
    error?: string,
    resource?: T,
    error_block?: string,
    query: iListingQuery
}

export const listReducer: <TS extends iListResource<T>,
    T extends iListResponseActions<T>>(initialEntity: T) => Reducer<iListResource<T>, iListResponseActions<T>> = (initialEntity) => {
    return (state, action) => {
        if (!state) return {query: {}, loading: true, soft_loading: true};
        switch (action.type) {
            case 'loading':
                return {...state, loading: true};
            case 'soft_loading':
                return {...state, soft_loading: true};
            case 'failed':
                return {...state, loading: false, soft_loading: false, error: action.error};
            case 'failed_to_load':
                return {...state, loading: false, soft_loading: false, error_block: action.error};
            case 'success':
                return {...state, resource: action.resource, loading: false, soft_loading: false};
            case 'query':
                return {...state, query: {...action.query}};
            case 'go_to_page':
                return {...state, query: {...state.query, page: action.page}};
            case 'per_page':
                return {...state, query: {...state.query, per_page: action.per_page}};
            case 'on_sort_change':
                return {...state, query: {...state.query, ...action.query}};
            case 'search':
                return {...state, query: {...state.query, keyword: action.keyword}};
            default:
                return {...state, loading: true};
        }
    }
}


export const loading_action = (): iListResponseActions<any> => {
    return {type: "loading"}
};

export const soft_loading_action = (): iListResponseActions<any> => {
    return {type: "soft_loading"}
};


export const onSortAction = (sort_order: string, sort_direction: "asc" | "desc"): iListResponseActions<any> => {
    return {type: "on_sort_change", query: {sort_order: sort_order, sort_direction: sort_direction}}
};
export const per_page_row_change_action = (number: any): iListResponseActions<any> => {
    return {type: "per_page", per_page: number}
};
export const search_action = (keyword: string): iListResponseActions<any> => {
    return {type: "search", keyword: keyword}
};
export const current_page_change_action = (number: any, history?: any): iListResponseActions<any> => {
    history && history.push({
        search: getPageQuery(number)
    });
    return {type: "go_to_page", page: number}
};

export const failed_action = (error?: string): iListResponseActions<any> => {
    return {type: "failed", error: error}
};
export const failed_block_action = (error?: string): iListResponseActions<any> => {
    return {type: "failed_to_load", error: error}
};
export const success_action = (resource: any): iListResponseActions<any> => {
    return {type: "success", resource: resource}
};


export const loading_action_response = (): iResponseActions<any> => {
    return {type: "loading"}
};


export const failed_action_response = (error?: string): iResponseActions<any> => {
    return {type: "failed", error: error}
};
export const failed_block_action_response = (error?: string): iResponseActions<any> => {
    return {type: "failed_to_load", error: error}
};
export const success_action_response = (resource: any): iResponseActions<any> => {
    return {type: "success", response: resource}
};

export type iResponseActions<T> =
    | { type: "loading" }
    | { type: "failed_to_load", error?: string }
    | { type: "failed", error?: string }
    | { type: "success", response?: T }

export interface iResource<T> {
    loading?: boolean,
    error_block?: string,
    error?: string,
    response?: T,
}

export const responseReducer: <TS extends iResource<T>,
    T extends iResponseActions<T>>(initialEntity: T) => Reducer<iResource<T>, iResponseActions<T>> = (initialEntity) => {
    return (state, action) => {
        if (!state) return {loading: true};
        switch (action.type) {
            case 'loading':
                return {...state, loading: true};
            case 'failed_to_load':
                return {...state, loading: false, error_block: action.error};
            case 'failed':
                return {...state, loading: false, error: action.error};
            case 'success':
                return {...state, response: action.response, loading: false};
            default:
                return {...state, loading: false};
        }
    }
};




